const productDetailSwiper = new Swiper(".js-productDetailSwiper", {
  loop: false,
  centeredSlides: true,
  slidesPerView: 1.75,
  spaceBetween: 16,
  autoplay: {
    delay: 3000,
  },

  breakpoints: {
    750: {
      spaceBetween: 24,
      autoplay: {
        delay: 3000,
      },
    },
  },
});
